/**
 * PULSE Buy Options
 * ------------------------------------------------------------
 * Single pair vs bundles, chosen inside the purchase area.
 *
 * - "Single pair" leaves the normal variant + add-to-cart path
 *   untouched, so existing form-bound analytics still fire.
 * - Selecting a bundle repoints Add to Bag at that bundle.
 *   Bundles needing a Short/Long split open the mix picker.
 * - On mobile the bundle list collapses behind a toggle.
 */
(function(){

  var state = { kind: 'single', variantId: null, mixSize: 0, mixTitle: '' };

  function els(){
    return {
      wrap: document.getElementById('BuyOptions'),
      toggle: document.getElementById('BuyOptionsToggle'),
      bundles: document.getElementById('BuyOptionsBundles'),
      picker: document.getElementById('VariantPicker'),
      submit: document.getElementById('ProductSubmit'),
      singlePrice: document.getElementById('BuyOptionSinglePrice'),
      singleSub: document.getElementById('BuyOptionSingleSub')
    };
  }

  function currentFit(){
    var sel = document.querySelector('#VariantPicker .variant-pill.is-selected');
    return sel ? sel.getAttribute('data-value') : '';
  }

  function openBundles(){
    var e = els();
    if(!e.bundles || !e.toggle) return;
    e.bundles.classList.add('is-open');
    e.toggle.setAttribute('aria-expanded', 'true');
  }

  function announce(detail){
    window.dispatchEvent(new CustomEvent('pulse:option-changed', { detail: detail }));
  }

  function setSelected(btn){
    var e = els();
    if(!e.wrap) return;

    e.wrap.querySelectorAll('.buy-option').forEach(function(b){
      var on = (b === btn);
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var kind = btn.getAttribute('data-option-kind');
    state.kind = kind;

    if(kind === 'single'){
      state.variantId = null;
      state.mixSize = 0;

      if(e.picker) e.picker.classList.remove('is-muted');

      if(e.submit){
        e.submit.textContent = e.submit.dataset.label || 'Add to Bag';
        e.submit.removeAttribute('data-bundle-size');
        e.submit.removeAttribute('data-bundle-title');
        e.submit.removeAttribute('data-variant-id');
      }

      announce({
        kind: 'single',
        price: e.singlePrice ? e.singlePrice.textContent : '',
        label: currentFit(),
        cta: (e.submit && e.submit.dataset.label) || 'Add to Bag'
      });

    } else {
      state.variantId = btn.getAttribute('data-variant-id');
      state.mixSize = parseInt(btn.getAttribute('data-bundle-size'), 10) || 0;
      state.mixTitle = btn.getAttribute('data-bundle-title') || '';

      if(e.picker) e.picker.classList.add('is-muted');

      var cta = state.mixSize > 0 ? 'Choose Your Mix' : 'Add Bundle to Bag';

      if(e.submit){
        e.submit.dataset.label = e.submit.dataset.label || e.submit.textContent.trim();
        e.submit.textContent = cta;
        e.submit.disabled = false;
        e.submit.setAttribute('data-variant-id', state.variantId);
        if(state.mixSize > 0){
          e.submit.setAttribute('data-bundle-size', state.mixSize);
          e.submit.setAttribute('data-bundle-title', state.mixTitle);
        } else {
          e.submit.removeAttribute('data-bundle-size');
          e.submit.removeAttribute('data-bundle-title');
        }
      }

      var titleEl = btn.querySelector('.buy-option-title');
      var shortTitle = titleEl ? titleEl.childNodes[0].textContent.trim() : 'Bundle';

      announce({
        kind: 'bundle',
        price: btn.getAttribute('data-price') || '',
        label: shortTitle,
        cta: cta
      });

      openBundles();
    }
  }

  function init(){
    var e = els();
    if(!e.wrap || e.wrap.dataset.pulseInit === '1') return;
    e.wrap.dataset.pulseInit = '1';

    if(e.submit) e.submit.dataset.label = e.submit.textContent.trim();

    if(e.toggle && e.bundles){
      e.toggle.addEventListener('click', function(){
        var open = e.bundles.classList.toggle('is-open');
        e.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    e.wrap.addEventListener('click', function(ev){
      var btn = ev.target.closest('.buy-option');
      if(!btn) return;
      ev.preventDefault();
      setSelected(btn);
    });

    /* Choosing a fit implies the single-pair option */
    if(e.picker){
      e.picker.addEventListener('click', function(ev){
        if(!ev.target.closest('.variant-pill')) return;
        if(state.kind !== 'single'){
          var single = e.wrap.querySelector('[data-option-kind="single"]');
          if(single) setSelected(single);
        }
      });
    }

    /* Keep the single-pair row in step with the variant */
    window.addEventListener('pulse:variant-changed', function(ev){
      if(!ev.detail) return;
      if(e.singlePrice && ev.detail.price) e.singlePrice.textContent = ev.detail.price;
      if(e.singleSub && ev.detail.fit){
        e.singleSub.textContent = 'One pair — ' + ev.detail.fit + ' fit';
      }
    });
  }

  /* Identify the product form by its ACTION, never by form.id.

     The form contains <input name="id" id="ProductVariantId">, and
     HTML exposes form fields as properties on the form by name — so
     `form.id` returns that input element, not the string. The old
     check (form.id !== 'ProductForm') was therefore always true,
     which silently disabled this entire interception: selecting the
     one non-mix bundle (Short + Long) and pressing "Add Bundle to
     Bag" fell through to the plain handler and added a SINGLE pair.

     Mix bundles were unaffected — pulse-bundle-mix.js catches those
     on click via [data-bundle-size], which never touches the form. */
  function isProductForm(form){
    if(!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    if(action.indexOf('/cart/add') !== -1) return true;
    return !!form.querySelector('#ProductVariantId');
  }

  /* Intercept submit only when a bundle is selected.
     Single-pair purchases fall through untouched so any existing
     form-bound tracking continues to fire exactly as before. */
  document.addEventListener('submit', function(ev){
    var form = ev.target;
    if(!isProductForm(form)) return;
    if(state.kind !== 'bundle') return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    var submit = document.getElementById('ProductSubmit');

    if(state.mixSize > 0){
      var proxy = document.createElement('button');
      proxy.setAttribute('data-bundle-size', state.mixSize);
      proxy.setAttribute('data-bundle-title', state.mixTitle);
      proxy.setAttribute('data-variant-id', state.variantId);
      proxy.style.display = 'none';
      document.body.appendChild(proxy);
      proxy.click();
      setTimeout(function(){ proxy.remove(); }, 0);
      return;
    }

    if(!window.PulseCart) return;
    var original = submit ? submit.textContent : '';
    if(submit){ submit.disabled = true; submit.textContent = 'Adding…'; }

    window.PulseCart.add(state.variantId, 1)
      .then(function(){
        if(submit){ submit.disabled = false; submit.textContent = original; }
        window.PulseCart.openDrawer();
      })
      .catch(function(err){
        console.error('PULSE: bundle add failed', err);
        if(submit){ submit.disabled = false; submit.textContent = original; }
      });
  }, true);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pulse:navigated', init);
})();
